import type { CRMNote } from "@/types";

export enum GovernanceRole {
  BOARD_MEMBER = "BOARD_MEMBER",
  COMMITTEE_MEMBER = "COMMITTEE_MEMBER",
  SELECTION_COMMITTEE_MEMBER = "SELECTION_COMMITTEE_MEMBER",
  CLUB_OFFICER = "CLUB_OFFICER",
  OWNER = "OWNER"
}

export enum GovernanceStatus {
  ACTIVE = "ACTIVE",
  ARCHIVED = "ARCHIVED"
}

export interface GovernanceTitle {
  id: string;
  title: string;
}

export interface FacilityGovernancePerson {
  id: string;
  displayName: string;
  pgaId: string | null;
  profilePhoto?: string;
  latestProgram: {
    programType: {
      id: string;
      name: string;
    };
  } | null;
}

export interface FacilityGovernanceRole {
  id: string;
  status: GovernanceStatus;
  title: GovernanceTitle;
  person: FacilityGovernancePerson;
  notes: CRMNote[];
}
